import { graphql } from 'react-apollo'
import withQueryParams from 'components/withQueryParams'
import { compose } from 'recompose'
import { withRouter } from 'react-router-dom'
import { isConnectionEnd } from 'utils/relay'
import findValue from 'utils/findValue'

const optionsDefaults = {
  fetchPolicy: 'cache-and-network'
}

const withConnectionQuery = ({
  graphqlQuery,
  paginated,
  namespace,
  perPage = 25
}) =>
  compose(
    withRouter,
    withQueryParams,
    graphql(graphqlQuery, {
      options: ({ query, variables }) => ({
        ...optionsDefaults,
        variables: paginated
          ? { first: perPage, q: query.get('q') || '', ...variables }
          : variables
      }),
      props: ({ ownProps, data }) => {
        const { loading, fetchMore } = data
        const connection = findValue(data, namespace)

        const baseProps = { loading, connection, ...ownProps }
        if (!paginated) {
          return baseProps
        }

        return {
          ...baseProps,
          loadMoreEntries: direction => {
            if (isConnectionEnd(connection, direction)) {
              return
            }
            const { edges } = connection
            const forward = direction === 'forward'
            const lastNode = forward ? edges[edges.length - 1] : edges[0]
            const cursorKey = forward ? 'after' : 'before'
            const variables = {
              first: forward ? perPage : null,
              last: forward ? null : perPage,
              [cursorKey]: lastNode.cursor,
              q: ownProps.query.get('q') || '',
              ...ownProps.variables
            }

            return fetchMore({
              graphqlQuery,
              variables,
              updateQuery: (previousResult, { fetchMoreResult }) => {
                const connectionQuery =
                  findValue(fetchMoreResult, namespace) || {}
                const { edges } = connectionQuery
                return edges && edges.length ? fetchMoreResult : previousResult
              }
            })
          }
        }
      }
    })
  )

export default withConnectionQuery



// WEBPACK FOOTER //
// ./src/components/withConnectionQuery.js